import { mdStyle, smStyle, xsStyle } from '@/components/Adapter'
import { Flex } from '@mantine/core'
import styled, { css } from 'styled-components'
import { Button } from '@gate/gui'

export const CoinListStyled = styled.div<{ isDark: boolean }>`
  width: 100%;
  height: 100%;
  max-height: 246px;
  box-sizing: border-box;
  padding: 12px 16px;
  border-radius: 8px;
  background: ${({ isDark }) => (isDark ? `none` : 'var(--color-card-3);')};
  border: 1px solid var(--color-divider-2);
  display: flex;
  flex-direction: column;
  max-width: calc(100vw - 24px);

  .coin-list-swiper-box {
    display: none;
  }

  &:hover {
    .coin-list-swiper-box {
      display: flex;
    }
  }

  li {
    list-style: none;
  }

  ${mdStyle} {
    width: calc((100% - 32px) / 3);
    height: auto;
  }

  ${xsStyle} {
    max-width: calc(100vw - 32px);
  }

  ${smStyle} {
    max-width: calc(100vw - 48px);
  }
`

export const CoinListItemStyled = styled(Flex)`
  width: 100%;
  height: 48px;
  box-sizing: border-box;

  .price-coin-item {
    width: 100%;
    padding: 12px;

    &:hover {
      background: var(--color-neutral-2);
    }
  }

  & > .price-coin-new-item {
    background: #f2b80c1a;
  }
`

export const CoinMoreStyled = styled(Flex)`
  white-space: nowrap;
  color: var(--color-text-3);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;

  &[data-ar='true'] {
    transform: rotate(180deg);
  }
`

export const CoinListSwiperStyled = styled.div`
  position: relative;
  width: 100%;

  .swiper-slide {
    margin: 0 !important;
  }
`
export const CoinListSwiperCardStyled = styled.ul`
  width: 100%;
  height: 144px;
  display: flex;
  flex-direction: column;
`

export const CoinListSwiperActionStyled = styled.div`
  position: absolute;
  top: 28%;
  width: 100%;
  z-index: 1;
  justify-content: space-between;
`

export const CoinListSwiperButton = styled(Button)<{ isHide: boolean }>`
  margin-left: -32px;
  width: 28px;
  height: 28px;
  opacity: ${({ isHide }) => (isHide ? 0 : 1)};
  .mantine-GateButton-inner {
    width: 28px;
    height: 28px;
  }
`

export const CoinListSwiperRightButton = styled(CoinListSwiperButton)`
  margin-right: -32px;
`

export const CoinListCurrencyItemStyled = styled.a`
  display: flex;
  justify-content: space-between;
`
